import ArrowRightIcon from '../../../../atoms/icons/arrowRight';
import ArrowLeftIcon from '../../../../atoms/icons/arrowLeft';
import FilterArrowRightContainer from '@components/atoms/container/filterArrowRightContainer';
import FilterArrowLeftContainer from '@components/atoms/container/filterArrowLeftContainer';
import HorizontalArrowLeftContainer from '../../../../atoms/container/horizontalArrowLeftContainer';
import HorizontalArrowRightContainer from '../../../../atoms/container/horizontalArrowRightContainer';
import Pages from '../../../../../../shared/types/enums/pages';
import SquareArrowLeftContainer from '../../../../atoms/container/squareArrowLeftContainer';
import SquareArrowRightContainer from '../../../../atoms/container/squareArrowRightContainer';
import useInterval from '../../../../../../shared/components/utils/hooks/useInterval';
import { MutableRefObject } from 'react';
import { RailDisplayMode } from '../../../../../../shared/types/enums/rail';
import { magicRemoteSelector } from '../../../../../../shared/store/slices/magicRemote.slice';
import { routerSelector } from '../../../../../../shared/store/slices/router.slice';
import { useAppSelector } from '../../../../../../shared/store/hooks';
import { userSelector } from '@shared/store/slices/user.slice';

interface Props {
  displayMode: RailDisplayMode;
  setListIndex: MutableRefObject<(index: number, increment: number) => void>;
}

function ArrowsSelector({ displayMode, setListIndex }: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { route } = useAppSelector(routerSelector);
  const { isAnonymous } = useAppSelector(userSelector);
  const [interval, cancelInterval] = useInterval(200);

  // If magic remote is not enabled, do not continue

  if (!enabled) return null;

  // Filter buttons

  if (displayMode === RailDisplayMode.FILTER) {
    const hasSearchBar = route.Page !== Pages.CLASSIC_CHANNEL;
    return (
      <>
        <FilterArrowRightContainer
          animation={'opacity-transition'}
          anonymous={isAnonymous}
          enabled={enabled}
          hasSearchBar={hasSearchBar}
          onMouseEnter={() => interval(() => setListIndex.current(0, 1))}
          onMouseLeave={cancelInterval}
        >
          <ArrowRightIcon height={24} color={'#FFFFFF'} />
        </FilterArrowRightContainer>
        <FilterArrowLeftContainer
          hasSearchBar={hasSearchBar}
          animation={'opacity-transition'}
          anonymous={isAnonymous}
          enabled={enabled}
          onMouseEnter={() => interval(() => setListIndex.current(0, -1))}
          onMouseLeave={cancelInterval}
        >
          <ArrowLeftIcon height={24} color={'#FFFFFF'} />
        </FilterArrowLeftContainer>
      </>
    );
  }

  // Square cards

  if (displayMode === RailDisplayMode.SQUARE) {
    return (
      <>
        <SquareArrowRightContainer
          animation={'opacity-transition'}
          onMouseEnter={() => interval(() => setListIndex.current(0, 1))}
          onMouseLeave={cancelInterval}
          offset={route.Page === Pages.SEARCH ? 1390 : 1766}
        >
          <ArrowRightIcon width={25} height={35} color={'#FFFFFF'} />
        </SquareArrowRightContainer>
        <SquareArrowLeftContainer
          animation={'opacity-transition'}
          onMouseEnter={() => interval(() => setListIndex.current(0, -1))}
          onMouseLeave={cancelInterval}
        >
          <ArrowLeftIcon width={25} height={35} color={'#FFFFFF'} />
        </SquareArrowLeftContainer>
      </>
    );
  }

  // Horizontal and vertical cards

  if (Object.values(RailDisplayMode).includes(displayMode)) {
    return (
      <>
        <HorizontalArrowRightContainer
          animation={'opacity-transition'}
          onMouseEnter={() => interval(() => setListIndex.current(0, 1))}
          onMouseLeave={cancelInterval}
          offset={route.Page === Pages.SEARCH ? 1360 : 1730}
          vertical={displayMode === RailDisplayMode.POSTER}
        >
          <ArrowRightIcon width={50} height={70} color={'#FFFFFF'} />
        </HorizontalArrowRightContainer>
        <HorizontalArrowLeftContainer
          hasLeftButton={displayMode === RailDisplayMode.CHANNEL_GUIDE_PHOTO}
          animation={'opacity-transition'}
          onMouseEnter={() => interval(() => setListIndex.current(0, -1))}
          onMouseLeave={cancelInterval}
          vertical={displayMode === RailDisplayMode.POSTER}
        >
          <ArrowLeftIcon width={50} height={70} color={'#FFFFFF'} />
        </HorizontalArrowLeftContainer>
      </>
    );
  }

  return null;
}

export default ArrowsSelector;
